<template>
  <div class="mt-8">
    <px-view-module-header module-name="Marketplace" :breadcrumbs="breadcrumbs"/>
    <v-card class="rounded-card card-shadow mt-8">
      <v-card-text class="text--primary">
        <px-view-header-title title="Perguntas">
          <template v-slot:before>
            <v-btn class="mb-1 mr-1" icon x-large color="primary" @click="onClickBack">
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </template>
        </px-view-header-title>
        <div v-if="loading">
          <px-circular-loading/>
        </div>
        <div v-if="!loading && oferta" class="mt-5">
          <v-row dense>
            <v-col cols="12">
              <v-alert
                type="info"
                class="rounded-card"
                outlined
                dismissible>
                Todas as perguntas são públicas.
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="mx-2 headline font-weight-bold">
              <span>
                {{ oferta.titulo }}
              </span>
              <small>
                ({{ oferta.codigo }})
              </small>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <px-oferta-duvidas :oferta="oferta"/>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import OfertaService from '../oferta-service';
import OfertaDuvidas from '../perguntas/OfertaDuvidas.vue';

export default {
  data() {
    return {
      loading: false,
      oferta: null,
      id: this.$route.params.id,
      compradorSelecionado: null,
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.marketplace.ofertas' });
    },
    getOferta() {
      this.loading = true;
      OfertaService.get(this.id)
        .then(({ data }) => {
          this.oferta = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getOferta();
  },
  components: {
    pxOfertaDuvidas: OfertaDuvidas,
  },
};
</script>
